import {
	CHANGE_ACTIVE_TAB,
	CHANGE_APPLICATION_POLICY_SETTINGS,
	TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
	REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
	RECEIVE_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
	RECEIVE_BAD_REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
	RECEIVE_GET_TRANSFER_OUTCOME,
	CHECK_USER_OVERVIEW_TAB_CHECKBOX,
	DOWNLOAD_FILE,
	LOGOUT,
	RECEIVE_BAD_REQUEST_DELETE_DOCUMENT,
	RECEIVE_DELETE_DOCUMENT_RESPONSE,
	REQUEST_DELETE_DOCUMENT,
	SELECT_ACTIVE_TAB_NOTIFICATION,
	RECEIVE_PATCH_NOTIFICATION,
	RECEIVE_POST_OVERVIEW_POLICY_FORM,
	REQUEST_PATCH_APPLICATION,
	RECEIVE_PATCH_APPLICATION,
	RECEIVE_BAD_REQUEST_PATCH_APPLICATION,
	RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION,
	REQUEST_PATCH_NOTIFICATION,
	RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_APPLICATION_PREMIUM_SETTINGS,
	REQUEST_APPLICATION_PREMIUM_SETTINGS,
	CHANGE_APP_PREMIUM_SETTINGS_FIELD,
	REQUEST_POST_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_BAD_REQUEST_POST_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS,
	REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
	RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM,
	RECEIVE_BAD_REQUEST_PATCH_APPLICATION_AFTER_PREMIUM_SETTINGS,
	CHANGE_SUB_SETTING_DAMAGES,
	RECEIVE_PREMIUM_SETTINGS_DAMAGES,
	RECEIVE_GET_SOLICITOR_GROUP_OF_APPLICATION,
	CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE,
	CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR,
	REQUEST_APPLICATION_ATTACHMENT,
	RECEIVE_APPLICATION_ATTACHMENT,
	RECEIVE_BAD_REQUEST_APPLICATION_ATTACHMENT,
	REQUEST_GET_APPLICATION_NOTIFICATION,
	RECEIVE_GET_APPLICATION_NOTIFICATION,
	RECEIVE_FAILURE_GET_APPLICATION_NOTIFICATION,
	CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS,
	CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY,
	RECEIVE_GET_POLICY_SCHEDULE,
	GET_POLICY_SCHEDULE,
	FAIL_GET_POLICY_SCHEDULE,
	OPEN_FILE_PREVIEW,
	CLOSE_FILE_PREVIEW,
	SET_FILE_PREVIEW_LOADING,
	SET_FILE_PREVIEW_ERROR,
	OPEN_RENAME_ATTACHMENT_MODAL,
	CLOSE_RENAME_ATTACHMENT_MODAL,
	REQUEST_RENAME_ATTACHMENT,
	RECEIVE_RENAME_ATTACHMENT_RESPONSE,
	RECEIVE_BAD_REQUEST_RENAME_ATTACHMENT,
	SELECT_APPLICATION_STATUS,
	CLOSE_PREMIUM_SETTINGS_MODAL,
} from "../actions/index";
import _ from 'lodash';
import {CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED, RECEIVE_CREATE_ADVANCED_DISBURSEMENT} from "../actions";
import {CREATE_APPLY_PIG, RECEIVE_APPLY_PIG, FAILED_TO_APPLY_PIG} from "../actions";
import {
    GET_APPLICATION_POLICY_WORDING, GET_APPLICATION_POLICY_WORDING_FAIL,
    GET_APPLICATION_POLICY_WORDING_SUCCESS, RECEIVE_GET_SELECTED_APPLICATION,
} from "../actions";
import {LEGAL_ADVICE_TEXT, NOT_FOUND_MESSAGE,COUNTRY,CANADA_COUNTRY} from "../helpers/variables";
import {
	ERROR,
	LOCAL_EMAIL_ATE,
	LOCAL_PHONE_NUMBER_ATE,
	WARNING,
	WORDING_ERROR_MESSAGE,
} from "../helpers/constants";

const defaultState = {
	activeTab:'application',
	updatePolicy: {},
	deleting:false,
	failedDeleteMsg: '',
	usersOverviewTabCheckBoxes: {
		all: false,
		arag: true,
		aragAndMedicalExperts: false
	},
	selectedStatus: '',
	selectedStatusMachineName: '',
	selectedReferredOptions: '',
	solicitorFirmIdSelected: '',
	solicitorFirmUserIdSelected: '',
	badResponseTransferApplication: '',
	transferError: '',
	transferErrorApplicationId: null,
	pollTransferOutcomeUntil: 0,
	transferringApplication: false,
	notificationId: null,
	notificationEventName: '',
	patching: false,
	modalPatchingMsg: '',
	patchApplicationAfterPremiumFailMessage: '',
	openModal: false,
	badResponsePatchNotification:'',
	responseMsgPatchNotification: '',
	updatingNotification: false,
	openPremiumSettingsModal: false,
	openTransferApplicationModal: false,
	premiumSettingsIndicator: false,
	makeApplicationLive:false,
	premiumSettings: {
		id: '',
		limitOfIndemnity: '',
		endorsements: '',
		comments: '',
		notes: '',
		applicationPremiumSubSettingsDtos: [],
		tableData: [],
		solicitorListLength: 0,
		solicitorsList: [],
		damageBands: [],
        isPlain: true,
        validationMessage: '',
		coveragesOptions:[],
		deductiblesOptions:[],
		endorsementsOptions:[],
		selectedCoverageType:'',
    	selectedDeductible:'',
    	selectedEndorsement:'',
    	displayedCoverageType:'',
    	displayedDeductible:'',
    	displayedEndorsement:'',
		appliedApplicationPremiumSubSettingsDtoIndex: null,
		highlightedContingentStageMachineName: null,
		highlightedNonContingentStageMachineName: null,
	},
	premiumSettingsBadResponse: '',
	premiumSettingsSubSettingsDamages:{},
	premiumSettingsDamages: [],
	sendEmailNotification: false,
	solicitorGroup: {},
	failedToReceivePremiumMsg: '', //variable that if no premium exists, it displayes an error message
	multipleAppPremiumSettingsFound:false,
	documentToDownload: {},
	fetchingDocument: false,
	failedToGetDocumentMsg: '',
	filePreview: {
		isOpen: false,
		file: null,
		loading: false,
		error: null
	},
	notification: {},
	fetchingNotification: false,
	fetchingNotificationFailureMsg:'',
	fetchingWording: false,
	wording: {},
	wordingId: '',
	failedToGetWording: '',
	advancedDisbursementsApplicationModalOpen: false,
	openApplyPigModal: false,
	applyingPig: false,
	badResponseApplyPig: '',
	isPolicyLawsysFirmBankAccountValid: true,
	checkLawsysFirmBankAccountValidityErrorMessage: "",
	checkLawsysFirmBankAccountValidityErrorMessageBoxStyle: WARNING,
	ipid: {},
	failedToGetIPID: '',
	fetchingIPID: false,
	documentData:'',
	fetchingPolicySchedule:false,
	premiumSettingsChanged:false,
	premiumSettingsType:"",
	renameModalOpen: false,
	attachmentForRename: null,
	renaming: false,
	renameError: '',
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case GET_POLICY_SCHEDULE:
			return {
				...state,
				fetchingPolicySchedule:true
				}
		case RECEIVE_GET_POLICY_SCHEDULE:
			return {
				...state,
				documentData:action.payload,
				fetchingPolicySchedule:false
				}
		case FAIL_GET_POLICY_SCHEDULE:
			return {
				...state,
				fetchingPolicySchedule:false
				}
		case CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY:
			return {
				...state,
				isPolicyLawsysFirmBankAccountValid: true
			};
		case CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS:
			return {
				...state,
				isPolicyLawsysFirmBankAccountValid: action.payload.body,
				checkLawsysFirmBankAccountValidityErrorMessage: action.payload.body ?
					null : `There is no valid bank account for this ${LEGAL_ADVICE_TEXT}.`,
				checkLawsysFirmBankAccountValidityErrorMessageBoxStyle: action.payload.body ? null : WARNING,
			};
		case CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED:
			let bankAccountResponseMessage = `Could not check if the ${LEGAL_ADVICE_TEXT} has a valid bank account`;
			return {
				...state,
				isPolicyLawsysFirmBankAccountValid: false,
				checkLawsysFirmBankAccountValidityErrorMessage: bankAccountResponseMessage,
				checkLawsysFirmBankAccountValidityErrorMessageBoxStyle: ERROR,
			};
		case GET_APPLICATION_POLICY_WORDING:
			return {
				...state,
				fetchingWording: true,
                failedToGetWording: ''
			};
		case GET_APPLICATION_POLICY_WORDING_SUCCESS:
			if(!action.payload.body) return {...state, fetchingWording: false};
			return {
				...state,
				wording: action.payload.body,
                fetchingWording: false
			};
		case GET_APPLICATION_POLICY_WORDING_FAIL:
			return {
				...state,
				fetchingWording: false,
                failedToGetWording: WORDING_ERROR_MESSAGE
			};
		case RECEIVE_GET_SELECTED_APPLICATION:
			if (!action.payload.wordingId) {
				return {
					...state,
					failedToGetWording: WORDING_ERROR_MESSAGE
				}
			}
		case RECEIVE_CREATE_ADVANCED_DISBURSEMENT:
			return {
				...state,
                advancedDisbursementsApplicationModalOpen: defaultState.advancedDisbursementsApplicationModalOpen
			};
        case RECEIVE_GET_SOLICITOR_GROUP_OF_APPLICATION:
			return {
				...state,
				solicitorGroup: action.payload
			};
		case RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM:
			return {
				...state,
				patching: false,
				selectedStatus: '',
				selectedStatusMachineName: '',
				selectedReferredOptions: '',
				activeTab: 'application',
				openModal:false,
				openPremiumSettingsModal: false,
				premiumSettingsIndicator: false,
				premiumSettingsBadResponse: '',
				makeApplicationLive: false,
				sendEmailNotification: false,
				// Must reset here: without this, subsequent cancel attempts (e.g. Lost → Live)
				// incorrectly treat the already-accepted ApplicationPremiumSetting as a
				// newly-created conflict record and hard-delete it.
				multipleAppPremiumSettingsFound: false,
			};
		case CHANGE_APP_PREMIUM_SETTINGS_FIELD:
			return{
				...state,
				premiumSettings: {
					...state.premiumSettings,
					[action.payload.key]: action.payload.value,
					validationMessage: action.payload.key === 'validationMessage'?action.payload.value:''
				}
			};
		case CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE:
            let newTableData = [...state.premiumSettings.tableData];
            newTableData[action.payload.tableIndex][action.payload.field] = action.payload.value;
			return {
				...state,
				premiumSettings: {
					...state.premiumSettings,
                    tableData: newTableData,
                    validationMessage: ''
                }
			};
        case CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR:
            newTableData = [...state.premiumSettings.tableData];
            newTableData[action.payload.tableIndex].premiumSubSettingCommissions[action.payload.solicitorIndex][action.payload.field] = action.payload.value;
            return {
                ...state,
                premiumSettings: {
                    ...state.premiumSettings,
                    tableData: newTableData,
                    validationMessage: ''
                }
            };
		case REQUEST_APPLICATION_PREMIUM_SETTINGS:
			return {
				...state,
				premiumSettingsIndicator: true,
				premiumSettingsBadResponse: '',
                modalPatchingMsg: defaultState.modalPatchingMsg,
                failedToReceivePremiumMsg: defaultState.failedToReceivePremiumMsg,
				openPremiumSettingsModal: (action.payload.openModal!== undefined )?true:false,
				openModal: (action.payload.openModal!== undefined)?false: state.openModal
			};
		case RECEIVE_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				premiumSettingsDamages: action.payload
			};
		case CHANGE_SUB_SETTING_DAMAGES:
			return {
				...state,
				premiumSettingsSubSettingsDamages: {
					...state.premiumSettingsSubSettingsDamages,
					[action.payload.subSettingId]: {
						...state.premiumSettingsSubSettingsDamages[action.payload.subSettingId],
						[action.payload.damageField]: action.payload.damageValue
					}
				}
			};
		case RECEIVE_APPLICATION_PREMIUM_SETTINGS:
			let premiumSettingsSubSettingsDamages = {};
			if(action.payload.hasOwnProperty('applicationPremiumSubSettingsDtos')){
				if(action.payload.applicationPremiumSubSettingsDtos.length > 0){
					let tData = [];
					let solicitorListLength = 0;
					solicitorListLength = action.payload.applicationPremiumSubSettingsDtos[0].premiumSubSettingCommissions.length;

					_.forEach(action.payload.applicationPremiumSubSettingsDtos, subSetting => {
						let tmp = [];
						let premium = subSetting.premium;
						_.forEach(subSetting.premiumSubSettingCommissions, item => {
							tmp.push({
								lawsysId: item.lawsysId,
                                lawsysName: item.lawsysName?item.lawsysName:'',
								commission: !isNaN(Number.parseFloat(item.commission)) ? item.commission.toString() : '',
								commissionPercentage: !isNaN(Number.parseFloat(item.commissionPercentage)) ? item.commissionPercentage.toString() : '',			
							})
						});
						tData.push({
							stageId: subSetting.stageId,
							stageName: subSetting.stageName,
							premium: !isNaN(Number.parseFloat(premium)) ? premium.toString() : '',
							recoverable: !isNaN(Number.parseFloat(subSetting.recoverable)) ? subSetting.recoverable.toString() : '',
							nonRecoverable: !isNaN(Number.parseFloat(subSetting.nonRecoverable)) ? subSetting.nonRecoverable.toString() : '',            
							underwriterRate: !isNaN(Number.parseFloat(subSetting.underwriterRate)) ? subSetting.underwriterRate.toString() : '',
							underwriterRatePercentage: !isNaN(Number.parseFloat(subSetting.underwriterRatePercentage)) ? subSetting.underwriterRatePercentage.toString() : '',
							premiumSubSettingCommissions: tmp,
							damages: _.sortBy(subSetting.damages, ['sortOrder']),
						})
					});
					return {
						...state,
						premiumSettings: {
							...state.premiumSettings,
							applicationPremiumSubSettingsDtos:  _.orderBy(tData, ['stageId']),
							id: action.payload.id,
							currentStep: 6,
							comments: action.payload.comments,
							endorsements: action.payload.endorsements,
							notes: action.payload.notes,
							limitOfIndemnity: action.payload.limitOfIndemnity.toString(),
							recoverableRatePercentage: action.payload.recoverableRatePercentage ? action.payload.recoverableRatePercentage.toString() : '',
							tableData: _.orderBy(tData, ['stageId', item => item.damages[0]?.sortOrder ?? 0]),
							solicitorListLength: solicitorListLength,
							isPlain:true,
							appliedApplicationPremiumSubSettingsDtoIndex: action.payload.appliedApplicationPremiumSubSettingsDtoIndex,
							highlightedContingentStageMachineName: action.payload.highlightedContingentStageMachineName ?? null,
							highlightedNonContingentStageMachineName: action.payload.highlightedNonContingentStageMachineName ?? null,
							selectedCoverageType:action.payload.coverageOptionId!= null ?action.payload.coverageOptionId : '',
							selectedDeductible: action.payload.deductibleOptionId != null ? action.payload.deductibleOptionId : '',
							selectedEndorsement: action.payload.endorsementOptionId != null ? action.payload.endorsementOptionId : '',
							displayedCoverageType: action.payload.coverageOptionName != null ? action.payload.coverageOptionName : '',
							displayedDeductible: action.payload.deductibleOptionName != null ? action.payload.deductibleOptionName : '',
							displayedEndorsement: action.payload.endorsementOptionName != null ? action.payload.endorsementOptionName : '',
							
						},
						premiumSettingsIndicator: false,
					};
				}
				else if (action.payload.applicationPremiumSubSettingsDtos.length == 0 && action.payload?.applicationStagedPremiumSubSettingDtos?.length > 0){
					return {
						...state,
				 		premiumSettingsIndicator: false,
						premiumSettings: {
							...state.premiumSettings,
							id: action.payload.id,
						}
					}
				}
			}
			return {
				...state,
				premiumSettingsIndicator: false
			};
		case RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS:
			let fetchApplicationsPremiumSettingsErrorMessage = '';
			let multiplePremiumSettingsFound = false;
			try {
                fetchApplicationsPremiumSettingsErrorMessage = action.payload.response.body.message;
            } catch (e) {
                fetchApplicationsPremiumSettingsErrorMessage = 'Failed to fetch application premium settings.'
            }
			if(fetchApplicationsPremiumSettingsErrorMessage.includes(
				'Multiple premium settings found'
			  ))
			  multiplePremiumSettingsFound=true;
			return{
				...state,
				premiumSettingsIndicator: false,
				openPremiumSettingsModal: false,
                failedToReceivePremiumMsg: fetchApplicationsPremiumSettingsErrorMessage,
				// Only override the flag when this response is the one that set it — an unrelated
				// bad-request (different error message) must not silently clear a true flag, which
				// would cause closePremiumSettingsModal to skip the conflict-flow delete.
				multipleAppPremiumSettingsFound: multiplePremiumSettingsFound || state.multipleAppPremiumSettingsFound,
			};
		case REQUEST_POST_APPLICATION_PREMIUM_SETTINGS:
			return{
				...state,
				premiumSettingsIndicator: true,
				makeApplicationLive: action.payload.makeApplicationLive
			};
		case RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS:
			premiumSettingsSubSettingsDamages = {};
			if(action.payload.hasOwnProperty('applicationPremiumSubSettingsDtos')){
				if(action.payload.applicationPremiumSubSettingsDtos.length > 0){

					let temp = action.payload.applicationPremiumSubSettingsDtos.map(subSetting =>{
						return {
							[subSetting.id]: { selectedDamages: subSetting.damageDtos, checkedDamagesIds: subSetting.damageDtos?subSetting.damageDtos.map(i => i.id): [],
								premium: subSetting.premium,
								recoverable: subSetting.recoverable,
								nonRecoverable: subSetting.nonRecoverable,
								underwriterRate: subSetting.underwriterRate,
								underwriterRatePercentage: subSetting.underwriterRatePercentage,
								commission: subSetting.commission,
								commissionPercentage: subSetting.commissionPercentage,
							}
						}
					});
					for(let i = 0; i < temp.length; i++){
						premiumSettingsSubSettingsDamages = {
							...premiumSettingsSubSettingsDamages, ...temp[i]
						}
					}
				}
			}
			return {
				...state,
				premiumSettingsIndicator: state.makeApplicationLive?true:false,
				premiumSettings: action.payload,
				premiumSettingsBadResponse: '',
				premiumSettingsSubSettingsDamages: premiumSettingsSubSettingsDamages
			};
		case RECEIVE_BAD_REQUEST_POST_APPLICATION_PREMIUM_SETTINGS:
			return{
				...state,
				premiumSettingsIndicator: false,
				premiumSettingsBadResponse: action.payload
			};
		case REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS:
			return{
				...state,
				premiumSettingsIndicator: true,
				makeApplicationLive: action.payload.makeApplicationLive,
                premiumSettingsBadResponse: '',
                modalPatchingMsg: defaultState.modalPatchingMsg
			};
		case RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS:
            let tData = [];
            let solicitorListLength = 0;
			if(action.payload.applicationPremiumSubSettingsDtos.length > 0 )
			{
				solicitorListLength = action.payload.applicationPremiumSubSettingsDtos[0].premiumSubSettingCommissions.length;
	
				_.forEach(action.payload.applicationPremiumSubSettingsDtos, subSetting => {
					let tmp = [];
					_.forEach(subSetting.premiumSubSettingCommissions, item => {
						tmp.push({
							lawsysId: item.lawsysId,
							commission: !isNaN(Number.parseFloat(item.commission)) ? item.commission.toString() : '',
							commissionPercentage: !isNaN(Number.parseFloat(item.commissionPercentage)) ? item.commissionPercentage.toString() : '',
						})
					});
					tData.push({
						stageId: subSetting.stageId,
						stageName: subSetting.stageName,
						premium: !isNaN(Number.parseFloat(subSetting.premium)) ? subSetting.premium.toString() : '',
						recoverable: !isNaN(Number.parseFloat(subSetting.recoverable)) ? subSetting.recoverable.toString() : '',
						nonRecoverable: !isNaN(Number.parseFloat(subSetting.nonRecoverable)) ? subSetting.nonRecoverable.toString() : '',            
						underwriterRate: !isNaN(Number.parseFloat(subSetting.underwriterRate)) ? subSetting.underwriterRate.toString() : '',
						underwriterRatePercentage: !isNaN(Number.parseFloat(subSetting.underwriterRatePercentage)) ? subSetting.underwriterRatePercentage.toString() : '',
						premiumSubSettingCommissions: tmp,
						damages: _.sortBy(subSetting.damages, ['sortOrder'])
					})
				});
				return {
					...state,
					premiumSettingsChanged:true,
					premiumSettings: {
						...state.premiumSettings,
						applicationPremiumSubSettingsDtos: _.orderBy(tData, ['stageId', item => item.damages[0]?.sortOrder ?? 0]),
						id: action.payload.id,
						currentStep: 6,
						comments: action.payload.comments,
										endorsements: action.payload.endorsements,
						notes: action.payload.notes,
						limitOfIndemnity: action.payload.limitOfIndemnity.toString(),
						tableData: _.orderBy(tData, ['stageId', item => item.damages[0]?.sortOrder ?? 0]),
						solicitorListLength: solicitorListLength,
						isPlain:true,
						appliedApplicationPremiumSubSettingsDtoIndex: action.payload.appliedApplicationPremiumSubSettingsDtoIndex,
						highlightedContingentStageMachineName: action.payload.highlightedContingentStageMachineName ?? null,
						highlightedNonContingentStageMachineName: action.payload.highlightedNonContingentStageMachineName ?? null,
					},
					premiumSettingsBadResponse: '',
					premiumSettingsIndicator: state.makeApplicationLive?true:false,
				};
			}
			else if (action.payload.applicationStagedPremiumSubSettingDtos.length > 0 ){
				return {
					...state,
					premiumSettingsChanged:true,
					premiumSettings: {
						...state.premiumSettings,
						applicationPremiumSubSettingsDtos: [],//action.payload.applicationPremiumSubSettingsDtos,
						applicationStagedPremiumSubSettingDtos: action.payload.applicationStagedPremiumSubSettingDtos,
						id: action.payload.id,
						// currentStep: 6,
						comments: action.payload.comments,
						endorsements: action.payload.endorsements,
						notes: action.payload.notes,
						limitOfIndemnity: action.payload.limitOfIndemnity.toString(),
						// tableData: _.orderBy(tData, ['stageId']),
						// solicitorListLength: solicitorListLength,
						// isPlain:true,
						highlightedContingentStageMachineName: action.payload.highlightedContingentStageMachineName ?? null,
						highlightedNonContingentStageMachineName: action.payload.highlightedNonContingentStageMachineName ?? null,
					},
					premiumSettingsBadResponse: '',
					premiumSettingsIndicator: state.makeApplicationLive?true:false,
				}
			}
			return {
				...state
			}
		case RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS:
			let patchApplicationPremiumSettingsFailResponse = '';
			try {
                patchApplicationPremiumSettingsFailResponse = action.payload.response.body.message;
			} catch (e) {
                patchApplicationPremiumSettingsFailResponse = 'Failed to update application premium setting.'
            }
			return{
				...state,
				premiumSettingsIndicator: false,
				premiumSettingsBadResponse: patchApplicationPremiumSettingsFailResponse
			};
		case RECEIVE_BAD_REQUEST_PATCH_APPLICATION_AFTER_PREMIUM_SETTINGS:
			let patchApplicationAfterPremiumFailMessage = '';
			try {
                patchApplicationAfterPremiumFailMessage = action.payload.response.body.message
            } catch (e) {
                patchApplicationAfterPremiumFailMessage = 'Failed to update application.'
            }
			return{
				...state,
				premiumSettingsIndicator: false,
				makeApplicationLive: false,
				openPremiumSettingsModal: false,
				patchApplicationAfterPremiumFailMessage: patchApplicationAfterPremiumFailMessage
			};

		case REQUEST_PATCH_APPLICATION:
			return {
				...state,
				patching:true
			};
		case RECEIVE_PATCH_APPLICATION:
			return {
				...state,
				patching: false,
				selectedStatus: '',
				selectedStatusMachineName: '',
				selectedReferredOptions: '',
				activeTab: 'application',
				openModal:false,
				openPremiumSettingsModal: false,
				sendEmailNotification: false
			};
		case RECEIVE_BAD_REQUEST_PATCH_APPLICATION:
			return {
				...state,
				patching: false,
				modalPatchingMsg: 'Error occurred while updating.',
				sendEmailNotification: false
			};
		case RECEIVE_POST_OVERVIEW_POLICY_FORM:
			return {
				...state,
				usersOverviewTabCheckBoxes: defaultState.usersOverviewTabCheckBoxes
			};
		case SELECT_APPLICATION_STATUS:
			return {
				...state,
				selectedStatus: action.payload.displayName,
				selectedStatusMachineName: action.payload.machineName,
				selectedReferredOptions: '',
				premiumSettingsType: '',
				sendEmailNotification: false,
				failedToReceivePremiumMsg: '',
				modalPatchingMsg: '',
				patchApplicationAfterPremiumFailMessage: '',
				multipleAppPremiumSettingsFound: false,
			};
		case CHANGE_APPLICATION_POLICY_SETTINGS:
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case CLOSE_PREMIUM_SETTINGS_MODAL:
			return {
				...state,
				multipleAppPremiumSettingsFound: false,
				openPremiumSettingsModal: false,
				premiumSettingsType: '',
			};
		case TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS:
			return {
				...state,
				[action.payload.key]: action.payload.value,
				badResponseTransferApplication: '',
			};
		case REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS:
			return {
				...state,
				badResponseTransferApplication: '',
				// Clear any previous banner and remember which policy this transfer is for, so an error
				// cannot follow the user to an unrelated policy (the slice is not reset on navigation).
				transferError: '',
				transferErrorApplicationId: action.payload.applicationId,
				pollTransferOutcomeUntil: 0,
				transferringApplication: true
			};
		case RECEIVE_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS:
			return {
				...state,
				badResponseTransferApplication: '',
				// US 101077: the transfer succeeded, but the downstream claim record may not have been
				// notified. Surfaced as an error banner on the policy page, since the modal closes here.
				transferError: (action.payload && action.payload.error) || '',
				// Poll only when the API says a reply is actually coming and there is no banner already.
				// 60s covers a slow BuD round trip; the outcome is persisted, so a later visit still shows it.
				pollTransferOutcomeUntil: (action.payload && action.payload.awaitingBudReply && !action.payload.error)
					? Date.now() + 60000
					: 0,
				transferringApplication: false,
				openTransferApplicationModal: false
			};
		case RECEIVE_GET_TRANSFER_OUTCOME:
			if (!action.payload || !action.payload.error) return state;
			return {
				...state,
				transferError: action.payload.error,
				pollTransferOutcomeUntil: 0,
			};
		case RECEIVE_BAD_REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS:
			let failedTransferMsg = '';
			try {
                failedTransferMsg = action.payload.response.body.message
            } catch (e) {
                failedTransferMsg = 'Failed to transfer application'
            }
			try {
				return {
					...state,
					transferringApplication: false,
					badResponseTransferApplication: JSON.parse(failedTransferMsg),
				};;
			}
			catch (e) {
				return {
					...state,
					transferringApplication: false,
					badResponseTransferApplication: failedTransferMsg,
				};
			}
		case CREATE_APPLY_PIG:
			return {
				...state,
				applyingPig: true,
				badResponseApplyPig: ''
			};
		case RECEIVE_APPLY_PIG:
			return {
				...state,
				applyingPig: false,
				openApplyPigModal: false
			};
		case FAILED_TO_APPLY_PIG:
			let failedPigMsg = '';
			try {
				failedPigMsg = action.payload.response.body.message;
			} catch (e) {
				failedPigMsg = 'Failed to apply Premium Indemnity Guarantee';
			}
			return {
				...state,
				applyingPig: false,
				badResponseApplyPig: failedPigMsg
			};
		case CHECK_USER_OVERVIEW_TAB_CHECKBOX:
			let newCheckBoxState = {...state.usersOverviewTabCheckBoxes};
			for(let index in state.usersOverviewTabCheckBoxes){
				if(index === action.payload){
					newCheckBoxState = {...newCheckBoxState, [index]: true}
				}
				else newCheckBoxState = {...newCheckBoxState, [index]: false}
			}
			return {
				...state,
				usersOverviewTabCheckBoxes : newCheckBoxState
			};
		case REQUEST_DELETE_DOCUMENT:
			return {
				...state,
				deleting :true,
                failedDeleteMsg: defaultState.failedDeleteMsg,
                failedToGetDocumentMsg: defaultState.failedToGetDocumentMsg
			};
		case RECEIVE_DELETE_DOCUMENT_RESPONSE:
			return {
				...state,
				deleting: false
			};
		case RECEIVE_BAD_REQUEST_DELETE_DOCUMENT:
			let failedDeleteMsg = '';
			try {
                failedDeleteMsg = action.payload.response.body.message
            } catch (e) {
                failedDeleteMsg = 'Failed to delete document'
            }
			return {
				...state,
				deleting: false,
				failedDeleteMsg: failedDeleteMsg,
			};
		case CHANGE_ACTIVE_TAB:
			return {
				...state,
				activeTab: action.payload,
				usersOverviewTabCheckBoxes: defaultState.usersOverviewTabCheckBoxes,
				responseMsgPatchNotification: ''
			};
		case DOWNLOAD_FILE:
			return {
				...state,
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState,
                activeTab: action.payload.location.pathname.includes('/application-and-policies/application-policy/')?
                    state.activeTab:defaultState.activeTab
            };
		case SELECT_ACTIVE_TAB_NOTIFICATION:
			return {
				...state,
				activeTab: action.payload.tab,
				notificationId: action.payload.notificationId,
				notificationEventName: action.payload.notificationEventName
			};
		case REQUEST_PATCH_NOTIFICATION:
			return {
				...state,
				badResponsePatchNotification: '',
				updatingNotification: true
			};
		case RECEIVE_PATCH_NOTIFICATION:
			return{
				...state,
				notificationId: null,
				notificationEventName: '',
				notification: {},
				badResponsePatchNotification: '',
				updatingNotification: false,
				responseMsgPatchNotification: 'Notification marked as viewed.'
			};
		case RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION:
			return{
				...state,
				badResponsePatchNotification: 'Error occurred while updating notification.',
				updatingNotification: false
			};
		case REQUEST_APPLICATION_ATTACHMENT:
			return {
				...state,
				fetchingDocument :true,
                failedToGetDocumentMsg: defaultState.failedToGetDocumentMsg,
                failedDeleteMsg: defaultState.failedDeleteMsg
			};
		case RECEIVE_APPLICATION_ATTACHMENT:
			if(!action.payload){
				return {
                    ...state,
                    fetchingDocument: false,
                    failedToGetDocumentMsg: NOT_FOUND_MESSAGE,
					filePreview: state.filePreview.isOpen ? {
						...state.filePreview,
						loading: false,
						error: NOT_FOUND_MESSAGE
					} : state.filePreview
				}
			}
			return {
				...state,
				fetchingDocument: false,
				documentToDownload: action.payload,
				failedToGetDocumentMsg:'',
				filePreview: state.filePreview.isOpen && state.filePreview.file?.id === action.payload.id ? {
					...state.filePreview,
					file: action.payload,
					loading: false,
					error: null
				} : state.filePreview
			};
		case RECEIVE_BAD_REQUEST_APPLICATION_ATTACHMENT:
			let failedToGetDocumentMsg = '';
			try {
                failedToGetDocumentMsg = action.payload.response.body.message;
            } catch (e) {
                failedToGetDocumentMsg = 'Failed to fetch document.'
            }
			return {
				...state,
				fetchingDocument: false,
				failedToGetDocumentMsg: failedToGetDocumentMsg,
				filePreview: state.filePreview.isOpen ? {
					...state.filePreview,
					loading: false,
					error: failedToGetDocumentMsg
				} : state.filePreview
			};
		case REQUEST_GET_APPLICATION_NOTIFICATION:
			return {
				...state,
				fetchingNotification :true
			};
		case RECEIVE_GET_APPLICATION_NOTIFICATION:
			return {
				...state,
				fetchingNotification: false,
				notification: action.payload,
				fetchingNotificationFailureMsg:''
			};
		case RECEIVE_FAILURE_GET_APPLICATION_NOTIFICATION:
			return {
				...state,
				fetchingNotification: false,
				fetchingNotificationFailureMsg: action.payload
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case OPEN_FILE_PREVIEW:
			return {
				...state,
				filePreview: {
					isOpen: true,
					file: action.payload,
					loading: !action.payload.encodedFile,
					error: null
				}
			};
		case CLOSE_FILE_PREVIEW:
			return {
				...state,
				filePreview: {
					isOpen: false,
					file: null,
					loading: false,
					error: null
				}
			};
		case SET_FILE_PREVIEW_LOADING:
			return {
				...state,
				filePreview: {
					...state.filePreview,
					loading: action.payload
				}
			};
		case SET_FILE_PREVIEW_ERROR:
			return {
				...state,
				filePreview: {
					...state.filePreview,
					loading: false,
					error: action.payload
				}
			};
		case OPEN_RENAME_ATTACHMENT_MODAL:
			return {
				...state,
				renameModalOpen: true,
				attachmentForRename: action.payload,
				renameError: ''
			};
		case CLOSE_RENAME_ATTACHMENT_MODAL:
			return {
				...state,
				renameModalOpen: false,
				attachmentForRename: null,
				renameError: ''
			};
		case REQUEST_RENAME_ATTACHMENT:
			return {
				...state,
				renaming: true,
				renameError: ''
			};
		case RECEIVE_RENAME_ATTACHMENT_RESPONSE:
			return {
				...state,
				renaming: false,
				renameModalOpen: false,
				attachmentForRename: null,
				renameError: ''
			};
		case RECEIVE_BAD_REQUEST_RENAME_ATTACHMENT:
			return {
				...state,
				renaming: false,
				renameError: action.payload
			};
		default:
			return state;
	}
}
